import _ from "lodash";
import React, { useEffect, useState } from "react";
import { TransitionGroup } from "react-transition-group";
import Bounce from "react-reveal/Bounce";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import QueryString from "query-string";
import { IonPage } from "@ionic/react";

import LoginForm from "./LoginForm";
import { authenticateAccount } from "../../modules";
import { clearAll } from "../../../common";

import { RegisterPanel } from "../register-page";
import { ResendActivationPanel } from "../resend-activation-page";
import { ResetPasswordPanel } from "../reset-password-page";
import { AccountActivationPanel } from "../account-activation-page";
import { ChangePasswordPanel } from "../change-password-page";

import styled from "styled-components";
const PageContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  background: radial-gradient(
      39.65% 65.44% at 100.97% 98.73%,
      #ffffff 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    #00cccc;
`;
const LogoContainer = styled.div`
  background: #00cccc;
  width: 60%;
  padding-right: 50px;
  padding-top: 35vh;
  background-image: url(${process.env.PUBLIC_URL +
  "assets/images/triumvi-auth-bg2.png"});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`;
const TriumviLogo = styled.div`
  color: #ffffff;
  font-family: Secular One;
  font-size: 10em;
  font-style: normal;
  font-weight: normal;
  line-height: 1em;
  letter-spacing: 0.05em;
  color: #ffffff;
  text-shadow: 0px 4px 10px #929292;
  text-align: right;
  z-index: 9999;
  position: relative;
`;
const TriumviSubtitle = styled.div`
  color: #ffffff;
  font-family: Secular One;
  font-size: 3.25em;
  font-style: normal;
  font-weight: normal;
  line-height: 1em;
  color: #ffffff;
  text-shadow: 0px 4px 5px #2cbfc9;
  text-align: right;
  z-index: 9999;
  position: relative;
`;
const FormContainer = styled.div`
  background: rgba(255, 255, 255, 0.15);
  height: 100vh;
`;

const LoginPanel = (props) => {
  return (
    <FormContainer>
      <LoginForm
        onSubmit={props.handleSubmitLogin}
        setRightPanel={props.setRightPanel}
        parsedQuery={props.parsedQuery}
        clearAll={props.clearAll}
      />
    </FormContainer>
  );
};

const getInitialRightPanel = (locationPathName) => {
  if (locationPathName === "/activate") {
    return "ACTIVATE";
  } else if (locationPathName === "/reset-password/confirm") {
    return "RESET_PASSWORD_CONFIRM";
  } else {
    return "LOGIN";
  }
};

let LoginPage = (props) => {
  const history = useHistory();
  const parsedQuery = QueryString.parse(props.location.search);
  const locationPathName = _.get(props.location, "pathname");

  const [rightPanel, setRightPanel] = useState(
    getInitialRightPanel(locationPathName)
  );

  useEffect(() => {
    if (props.credentials) {
      history.push(process.env.REACT_APP_DEFAULT_AUTHENTICATED_PATH);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const handleSubmitLogin = (values) => {
    props.authenticateAccount({
      values,
      successState: {
        context: "lib_authentication.authenticateAccount.loginPage",
        redirectPath: process.env.REACT_APP_DEFAULT_AUTHENTICATED_PATH,
      },
      errorState: (error) => ({
        notificationType: "alert",
        context: "lib_authentication.authenticateAccount.loginPage",
        ...error,
      }),
    });
  };

  let rightPanelDisplay = null;
  if (rightPanel === "LOGIN") {
    rightPanelDisplay = (
      <Bounce right spy={rightPanel} duration={2000}>
        <LoginPanel
          parsedQuery={parsedQuery}
          handleSubmitLogin={handleSubmitLogin}
          setRightPanel={setRightPanel}
          clearAll={props.clearAll}
        />
      </Bounce>
    );
  } else if (rightPanel === "REGISTER") {
    rightPanelDisplay = (
      <Bounce right spy={rightPanel} duration={2000}>
        <RegisterPanel setRightPanel={setRightPanel} history={history} />
      </Bounce>
    );
  } else if (rightPanel === "RESEND_ACTIVATION") {
    rightPanelDisplay = (
      <Bounce right spy={rightPanel} duration={2000}>
        <ResendActivationPanel setRightPanel={setRightPanel} />
      </Bounce>
    );
  } else if (rightPanel === "FORGOT_PASSWORD") {
    rightPanelDisplay = (
      <Bounce right spy={rightPanel} duration={2000}>
        <ResetPasswordPanel setRightPanel={setRightPanel} />
      </Bounce>
    );
  } else if (rightPanel === "ACTIVATE") {
    rightPanelDisplay = (
      <Bounce right spy={rightPanel} duration={2000}>
        <AccountActivationPanel
          parsedQuery={parsedQuery}
          setRightPanel={setRightPanel}
        />
      </Bounce>
    );
  } else if (rightPanel === "RESET_PASSWORD_CONFIRM") {
    rightPanelDisplay = (
      <Bounce right spy={rightPanel} duration={2000}>
        <ChangePasswordPanel
          parsedQuery={parsedQuery}
          setRightPanel={setRightPanel}
        />
      </Bounce>
    );
  }

  return (
    <IonPage>
      <PageContainer>
        <LogoContainer>
          <TriumviLogo>TRIUMVI</TriumviLogo>
          <TriumviSubtitle>BUSINESS MADE EASY.</TriumviSubtitle>
        </LogoContainer>
        <TransitionGroup style={{ width: "40%" }}>
          {rightPanelDisplay}
        </TransitionGroup>
      </PageContainer>
    </IonPage>
  );
};

const mapStateToProps = (state) => ({
  credentials: state.lib_authentication.credentials,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      authenticateAccount,
      clearAll,
    },
    dispatch
  );

LoginPage = connect(mapStateToProps, mapDispatchToProps)(LoginPage);
export default LoginPage;
